var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBeIconSmallBlu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-BE"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BE",
    clipPath: "url(#clip-BE)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_23217",
    "data-name": "Tracciato 23217",
    d: "M853.544-10604.753a24.749,24.749,0,0,0-6.8-8.876,28.077,28.077,0,0,0-18.126-6.809,27.542,27.542,0,0,0-12.669,3.1,28.415,28.415,0,0,0-10.4,9.286,26,26,0,0,0-4.428,15.17,25.979,25.979,0,0,0,4.428,15.168,26.556,26.556,0,0,0,10.61,9.394,28.719,28.719,0,0,0,12.462,2.887,26.576,26.576,0,0,0,9.27-1.755,32.278,32.278,0,0,0,8.857-5,24.33,24.33,0,0,0,6.747-8.667,27.193,27.193,0,0,0,2.626-12.022A27.553,27.553,0,0,0,853.544-10604.753Zm-24.926,27.71a15.88,15.88,0,0,1-15.862-15.894,15.876,15.876,0,0,1,15.862-15.892,15.875,15.875,0,0,1,15.861,15.892A15.878,15.878,0,0,1,828.619-10577.043Z",
    transform: "translate(-796.117 10625.438)",
    fill: "blue"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeIconSmallBlu);
export default __webpack_public_path__ + "static/media/be-icon-small-blu.7ca20b10.svg";
export { ForwardRef as ReactComponent };